export const FETCH_TODAYS_TRANSACTIONS = "FETCH_TODAYS_TRANSACTIONS";
export const FETCH_UNALLOCATED_TRANSACTIONS = "FETCH_UNALLOCATED_TRANSACTIONS";
